import { useQuery } from '@tanstack/react-query';
import { fetchBundleCategories } from './fetchBundleCategories';
import { GlobalReactQueryOptions } from '../../config';

type Params = {
    loanFormat: string;
    ageCategory?: string;
    shopLanguage: string | undefined;
};

const BUNDLE_CATEGORIES_KEY = `bundlesCategories`;

export const useBundleCategories = (params: Params) => {
    return useQuery([BUNDLE_CATEGORIES_KEY, params], () => fetchBundleCategories(params), {
        ...GlobalReactQueryOptions
    });
};
